import { Icons } from "@pushpress/shared-components";

const iconStyle = {
  width: "18px",
  height: "18px",
};

export const pageSearchActions = ({ isPeoplePageEnabled }) => [
  {
    name: "Add Member",
    targetPage: "/members/add",
    icon: <Icons.User style={iconStyle} />,
    isReactPage: false,
  },
  {
    name: "Add Lead",
    targetPage: "/members/lead_create",
    icon: <Icons.User style={iconStyle} />,
    isReactPage: false,
  },
  {
    name: "Create Invoice",
    targetPage: "/invoices/create",
    icon: <Icons.Payments style={iconStyle} />,
    isReactPage: false,
  },
  {
    name: "See all members",
    targetPage: isPeoplePageEnabled ? "/people/members" : "/members/index",
    icon: <Icons.Users style={iconStyle} />,
    isReactPage: isPeoplePageEnabled,
  },
  {
    name: "Dashboard",
    targetPage: "/main",
    icon: <Icons.Dashboard style={iconStyle} />,
    isReactPage: true,
  },
  {
    name: "Manage Staff",
    targetPage: isPeoplePageEnabled ? "/people/staff" : "/users/index",
    icon: <Icons.Users style={iconStyle} />,
    isReactPage: isPeoplePageEnabled,
  },
  {
    name: "Manage Plans",
    targetPage: "/plans/index",
    icon: <Icons.Plans style={iconStyle} />,
    isReactPage: false,
  },
  {
    name: "Appointments",
    targetPage: "/appointments",
    icon: <Icons.Appointments style={iconStyle} />,
    isReactPage: true,
  },
  {
    name: "Calendar",
    targetPage: "/schedule",
    icon: <Icons.Classes style={iconStyle} />,
    isReactPage: true,
  },
  {
    name: "Products",
    targetPage: "/products/index",
    icon: <Icons.Products style={iconStyle} />,
    isReactPage: false,
  },
];
